import React from 'react';
import { limitDecimals } from 'utils/numbers';

interface Props {
  /** Number value */
  value?: number;
  /** How many decimals to show (default to 1, or 0 for full numbers)? */
  decimals?: number;
}

/**
 * @todo This should likely be updated & re-used via AnimatedNumber.
 * @todo Proper storybooking
 */
export const NumberFormat: React.FC<Props> = props => {
  const { decimals = 1 } = props;
  const value = props.value || 0;
  const finalDecimals = !decimals || Number.isInteger(value) ? 0 : decimals;

  return <>{limitDecimals(value, finalDecimals)}</>;
};

export default NumberFormat;
